export class ResponseModel{
    
}